import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const BranchUserWalkthrough = ({ pathname, end, start}) => {

    const {personalization_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state

    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, createBranchUser:true}))
    }

    const endTour = ()=>{
        walkthrough.set((prev) => ({...prev, createBranchUser:false}))
    }

    useEffect(() => {
        start("setup", "branch-user-setup", startTour)
        //eslint-disable-next-line
    }, []);

    const steps =[
            {
                content: "Select the branch you want your user to be assigned at",
                placement: "right",
                target: "#walkthrough-branch-user-step-1",
                disableBeacon: true
            },
            {
                content: "Select the name of the user that you want to assigned the branch to",
                placement: "right",
                target: "#walkthrough-branch-user-step-2",
                disableBeacon: true
            },
            {
                content: "Click this to add more branch user",
                placement: "right",
                target: "#walkthrough-branch-user-step-3",
                disableBeacon: true
            },
            {
                content: "Click Save once done",
                placement: "right",
                target: "#walkthrough-branch-user-step-4",
                disableBeacon: true
            },
        ]

    return (
        <JoyrideWrapper 
            run={walkthrough.data.createBranchUser && window.location.pathname === pathname} 
            steps={steps} 
            setter={endTour} 
            end={end}
            p_name="branch-user-setup" 
            featureName="setup"
        />
    );
}
